import { Plugin } from '../Plugin';

require('jquery-asScrollbar/dist/jquery-asScrollbar.es');
require('jquery-asScrollable/dist/jquery-asScrollable.es');

const NAME = 'scrollable';

class Scrollable extends Plugin {
  getName() {
    return NAME;
  }

  static getDefaults() {
    return {
      namespace: 'scrollable',
      contentSelector: '> [data-role=\'content\']',
      containerSelector: '> [data-role=\'container\']'
    };
  }

  render() {
    let $el = this.$el;

    $el.asScrollable(this.options);
    if (this.options.direction === 'horizontal') {
      this.renderHorizontalBar($el);
      const self = this;
      $(window).resize(function(event) {
        self.clearStyles($el);
        self.renderHorizontalBar($el);
      });
    }

  }

  clearStyles($el){
    $el.removeAttr('style');
    $el.find('.top-scrollbar').remove();
    $el.find('.scrollable-container').removeClass('mt-10');
  }
  renderHorizontalBar($el){
    // hide scrollbar in Mozilla FF in Windows on horizontal scrolls
    let scrollbarHeight = 0;
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const isWindows = navigator.platform.indexOf('Win') > -1;
    if (isFirefox && isWindows) {
      scrollbarHeight = 16;
    }
    const container = $el.find('.scrollable-container')[0];
    let height = $(container).height() - scrollbarHeight;
    const scrollLeftMax = container.scrollWidth - container.clientWidth;

    // render second scroll bar, when option is given and when scrollbar is visible
    if (this.options['double'] === true && scrollLeftMax > 0) {
      this.createHorizontalBar($el);
      height = height + 10;
    }

    $el.attr('style', 'height: ' + height + 'px;');

  }

  createHorizontalBar($wrap) {
    /** build bar */
    let options = $.extend(this.options.scrollbar, {
      namespace: 'scrollable-bar',
      direction: 'horizontal',
      useCssTransitions: false,
      keyboard: false
    });
    let $bar = $('<div>');
    $bar.asScrollbar(options);

    const bottomBarHandle = $wrap.find('.scrollable-bar-handle');
    const scrollbarHandle = $bar.find('.scrollable-bar-handle');
    const style = bottomBarHandle.attr('style');
    $bar.prependTo($wrap);
    // position bar on top of container
    $bar.attr('style', 'top: 0px');
    $bar.addClass('top-scrollbar');
    scrollbarHandle.attr('style', style);
    const container = $wrap.find('.scrollable-container');
    container.addClass('mt-10');

    /** move bar synchronised to bottom bar */
    const callback = function (mutations) {
      mutations.forEach(function (mutationRecord) {
        scrollbarHandle.attr('style', bottomBarHandle.attr('style'));
      });
    };
    const observer = new MutationObserver(callback);
    const config = {attributes: true, attributeFilter: ['style']};
    observer.observe(bottomBarHandle[0], config);

    /** drag and drop scrolling on bar */
      // this is necessary, because bar jumps to left, if the scroll position is on right edge
    const callbackUpperScrollBarHandle = function (mutations) {
        mutations.forEach(function (mutationRecord) {
          if (scrollbarHandle.attr('style') !== bottomBarHandle.attr('style')) {
            scrollbarHandle.attr('style', bottomBarHandle.attr('style'));
          }
        });
      };
    const upperScrollBarHandleObserver = new MutationObserver(callbackUpperScrollBarHandle);

    // hover effect
    $bar.on('mouseenter', function () {
      $bar.addClass('is-hovering');
    });
    $bar.on('mouseleave', function () {
      $bar.removeClass('is-hovering');
    });

    // drag and drop on bar
    let dragging = false;
    let mouseStartPosX = 0;
    $bar.on('mousedown', function (event) {
      dragging = true;
      upperScrollBarHandleObserver.observe(scrollbarHandle[0], config);
      // for IE
      mouseStartPosX = event.clientX;
    });
    $(document).on('mousemove', function (event) {
      if (dragging) {
        const movementX = event.originalEvent['movementX'] || event.clientX - mouseStartPosX;
        const scrollLeftMax = container[0].scrollWidth - container[0].clientWidth; // container[0]['scrollLeftMax'];
        let scrollLeft = container.scrollLeft() + movementX;
        if (scrollLeft > scrollLeftMax - 10 && movementX > 0) {
          scrollLeft = scrollLeftMax;
        } else if (scrollLeft < 0) {
          scrollLeft = 0;
        }
        $(container[0]).scrollLeft(scrollLeft);
        mouseStartPosX = event.clientX;
      }
    });
    $(document).on('mouseup', function () {
      if (dragging) {
        dragging = false;
        upperScrollBarHandleObserver.disconnect();
      }
    });
  }
}

Plugin.register(NAME, Scrollable);

export default Scrollable;
